<template>
  <div class="tab-content">
    <div class="tab-pane fade show active">
      <div
        v-if="hasDummyLiquidFundsProcessedData"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="liquidFundsProcessedData"
        border
        style="width=100%"
        class="custom-scrollable-table header-color"
        :fixed="isSmallScreen ? 'left' : false"
        :default-sort="defaultSort"
        scrollbar-always-on
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin: 10px">
              Debt - Liquid &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Debt - Liquid', content1)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistliquidFunds"
          :class="{ 'no-sort-icon': isTrialExistliquidFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistliquidFunds"
          :class="{ 'no-sort-icon': isTrialExistliquidFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistliquidFunds"
          :class="{ 'no-sort-icon': isTrialExistliquidFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistliquidFunds"
          :class="{ 'no-sort-icon': isTrialExistliquidFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyVeryShortTermFundsProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="veryShortTermFundsProcessed"
        border
        style="width: 100%"
        scrollbar-always-on
        class="custom-scrollable-table header-color"
        :fixed="isSmallScreen ? 'left' : false"
        :default-sort="defaultSort"
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin: 5px">
              <span v-html="displayDebtHeader"></span>&nbsp;<img
                src="@/assets/images/circle.svg"
                @click="
                  openDialog('Very short term - 3 months to 1.5 yrs', content2)
                "
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistveryShortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistveryShortTermFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistveryShortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistveryShortTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistveryShortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistveryShortTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistveryShortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistveryShortTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyShortTermFundsProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="shortTermFundsProcessed"
        border
        style="width: 100%"
        class="custom-scrollable-table header-color"
        :fixed="isSmallScreen ? 'left' : false"
        :default-sort="defaultSort"
        scrollbar-always-on
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin: 5px">
              <span v-html="displayDebtShortHeader"></span>&nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Short term - 1.5 to 3 years', content3)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistshortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistshortTermFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistshortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistshortTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistshortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistshortTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistshortTermFunds"
          :class="{ 'no-sort-icon': isTrialExistshortTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyMediumTermFundsProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="mediumTermFundsProcessed"
        border
        style="width: 100%"
        scrollbar-always-on
        class="custom-scrollable-table header-color"
        :fixed="isSmallScreen ? 'left' : false"
        :default-sort="defaultSort"
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin: 5px">
              <span v-html="displayDebtMediumHeader"></span>&nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Medium term - 3 to 5 years', content4)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistmediumTermFunds"
          :class="{ 'no-sort-icon': isTrialExistmediumTermFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistmediumTermFunds"
          :class="{ 'no-sort-icon': isTrialExistmediumTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistmediumTermFunds"
          :class="{ 'no-sort-icon': isTrialExistmediumTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistmediumTermFunds"
          :class="{ 'no-sort-icon': isTrialExistmediumTermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div
        v-if="hasDummyLongtermFundsProcessed"
        class="subscribe-container text-center"
      >
        <img src="@/assets/images/lock.svg" />
        <span class="locked-message d-block mb-2 fw-bold">
          Subscribe now to unlock the full list of Prime Funds recommendations
        </span>
        <el-button
          type="primary"
          class="btn-color v-btn"
          @click="onSubscribeClick"
        >
          Subscribe now
        </el-button>
      </div>
      <el-table
        :data="longtermFundsProcessed"
        border
        style="width: 100%"
        class="custom-scrollable-table header-color"
        :fixed="isSmallScreen ? 'left' : false"
        :default-sort="defaultSort"
        scrollbar-always-on
        :row-class-name="getRowClassName"
      >
        <el-table-column
          label="Active"
          :width="columnWidth"
          :fixed="isSmallScreen ? 'left' : false"
        >
          <template #header>
            <div style="margin: 5px">
              <span v-html="displayDebtLongHeader"></span> &nbsp;<img
                src="@/assets/images/circle.svg"
                @click="openDialog('Long term - above 5 years', content5)"
                style="cursor: pointer; margin-bottom: 2px"
              />
            </div>
          </template>

          <template #default="scope">
            <span class="d-flex gap-data prime-funds">
              <div v-if="Number(scope.row.newFlag) === 1" class="new-tag">
                New
              </div>
              <el-tooltip
                :content="
                  Number(scope.row.inWatchlist) === 1
                    ? 'Remove from Watchlist'
                    : 'Add to Watchlist'
                "
                placement="top"
              >
                <img
                  :src="
                    Number(scope.row.inWatchlist) === 1 ? eyeRemove : eyeAdd
                  "
                  alt="Watchlist Status"
                  @click="toggleWatchlist(scope.row)"
                  class="watchlist-icon"
                />
              </el-tooltip>
              <div>
                <div
                  class="watchlist-container"
                  v-if="scope.row.showStatusMsg && scope.row.statusMessage"
                >
                  <div class="watchlist-status-overlay gap-data">
                    <img :src="eye" />
                    <span class="watchlist-status-message">
                      {{ scope.row.statusMessage }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span class="alert-message">
                    {{ scope.row.alertMessage }}
                  </span>
                </div>
              </div>
              <a
                :href="`${baseUrl}/scheme-details/?schemecode=${scope.row.schemeCode}`"
                target="_blank"
                class="fund-name text-decoration-none"
              >
                {{ scope.row.name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="primeRating"
          label="Ratings"
          width="100"
          :sortable="!isTrialExistlongtermFunds"
          :class="{ 'no-sort-icon': isTrialExistlongtermFunds }"
        >
          <template #default="scope">
            <span>
              {{
                scope.row.primeRating === null ||
                scope.row.primeRating === "null"
                  ? "Unrated"
                  : scope.row.primeRating + "★"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="oneYearReturn"
          label="1 year"
          width="100"
          :sortable="!isTrialExistlongtermFunds"
          :class="{ 'no-sort-icon': isTrialExistlongtermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'oneYearReturn')
          "
        >
          <template #default="scope">
            <span>{{
              scope.row.oneYearReturn === "0"
                ? "NA"
                : scope.row.oneYearReturn + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="threeYearCAGR"
          label="3 years"
          width="100"
          :sortable="!isTrialExistlongtermFunds"
          :class="{ 'no-sort-icon': isTrialExistlongtermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'threeYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>3 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.threeYearCAGR === "0"
                ? "NA"
                : scope.row.threeYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="fiveYearCAGR"
          label="5 years"
          width="100"
          :sortable="!isTrialExistlongtermFunds"
          :class="{ 'no-sort-icon': isTrialExistlongtermFunds }"
          :sort-method="
            (rowA, rowB) => sortByProperty(rowA, rowB, 'fiveYearCAGR')
          "
        >
          <template #header>
            <el-tooltip
              content="Returns over 1 year are annualised"
              placement="top"
            >
              <span>5 years</span>
            </el-tooltip>
          </template>
          <template #default="scope">
            <span>{{
              scope.row.fiveYearCAGR === "0"
                ? "NA"
                : scope.row.fiveYearCAGR + "%"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Strategy" width="200">
          <template #default="scope">
            <span style="padding-left: 26px; display: inline-block">
              {{ scope.row.schemeStrategy }}
              <img
                :src="popup"
                alt="Info"
                @click="showCommentPopup(scope.row)"
                class="funds-popup"
              />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <el-dialog
        v-model="isDialogVisible"
        class="fw-bold dialog-color"
        :title="dialogTitle"
        :width="popupwidth"
      >
        <p>{{ dialogContent }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isDialogVisible = false" class="v-btn btn-color"
            >Close</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        v-model="isCommentPopupVisible"
        :width="popupwidth"
        class="dialog-color"
      >
        <template #title>
          <div class="fw-bold">
            <h3>{{ selectedFund.name }}</h3>
          </div>
        </template>
        <p class="fw-bold">Research report</p>
        <hr />
        <div v-html="selectedFund.comment"></div>
        <div class="d-flex justify-content-center">
          <el-button
            @click="isCommentPopupVisible = false"
            class="v-btn btn-color"
          >
            Close
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

const store = useStore();
const eyeAdd = require("@/assets/images/eyeAdd.svg");
const eyeRemove = require("@/assets/images/eyeRemove.svg");
const popup = require("@/assets/images/helpcircle.svg");
const isSmallScreen = ref(false);
const baseUrl = process.env.VUE_APP_BASE_URL;
const popupwidth = computed(() => (isSmallScreen.value ? "100%" : "50%"));
const {
  getLiquidFunds,
  getLongTermFunds,
  getMediumTermFunds,
  getShortTermFunds,
  getVeryShortTermFunds,
} = store.getters;

const liquidFunds = computed(() => getLiquidFunds);
const longtermFunds = computed(() => getLongTermFunds);
const mediumTermFunds = computed(() => getMediumTermFunds);
const shortTermFunds = computed(() => getShortTermFunds);
const veryShortTermFunds = computed(() => getVeryShortTermFunds);
function onSubscribeClick() {
  const baseUrl = process.env.VUE_APP_BASE_URL;
  const subscriptionUrl = `${baseUrl}/prime-pricing`;
  window.open(subscriptionUrl, "_blank");
}
const hasDummyLiquidFundsProcessedData = computed(() => {
  return liquidFundsProcessedData.value.some((row) => row.isDummy);
});

const hasDummyLongtermFundsProcessed = computed(() => {
  return longtermFundsProcessed.value.some((row) => row.isDummy);
});
const hasDummyShortTermFundsProcessed = computed(() => {
  return shortTermFundsProcessed.value.some((row) => row.isDummy);
});

const hasDummyVeryShortTermFundsProcessed = computed(() => {
  return veryShortTermFundsProcessed.value.some((row) => row.isDummy);
});
const hasDummyMediumTermFundsProcessed = computed(() => {
  return mediumTermFundsProcessed.value.some((row) => row.isDummy);
});
const processData = (data) => {
  if (!Array.isArray(data)) {
    console.error("Data is not an array:", data);
    return [];
  }
  const actualData = data.map((row) => ({
    ...row,
    isDummy: false,
  }));
  const trialExists = actualData.some((row) => row.trial === "1");
  if (trialExists) {
    const dummyRows = actualData.slice(0, 2).map((row) => ({
      ...row,
      isDummy: true,
    }));
    const repeatedDummyRows = [...dummyRows, ...dummyRows];
    return [...actualData, ...repeatedDummyRows];
  }
  return actualData.sort(
    (a, b) => (b.fiveYearCAGR || 0) - (a.fiveYearCAGR || 0)
  );
};

const liquidFundsProcessedData = computed(() => {
  return processData(liquidFunds.value);
});

const longtermFundsProcessed = computed(() => {
  return processData(longtermFunds.value);
});
const mediumTermFundsProcessed = computed(() => {
  return processData(mediumTermFunds.value);
});
const shortTermFundsProcessed = computed(() => {
  return processData(shortTermFunds.value);
});
const veryShortTermFundsProcessed = computed(() => {
  return processData(veryShortTermFunds.value);
});
const checkTrialExists = (data) => {
  return data.some((row) => row.trial === "1");
};
const isTrialExistliquidFunds = computed(() =>
  checkTrialExists(liquidFunds.value)
);
const isTrialExistlongtermFunds = computed(() =>
  checkTrialExists(longtermFunds.value)
);
const isTrialExistmediumTermFunds = computed(() =>
  checkTrialExists(mediumTermFunds.value)
);
const isTrialExistshortTermFunds = computed(() =>
  checkTrialExists(shortTermFunds.value)
);
const isTrialExistveryShortTermFunds = computed(() =>
  checkTrialExists(veryShortTermFunds.value)
);
const getRowClassName = (row) => {
  const isDummy = row.row.isDummy === true;
  return isDummy ? "blur-row" : "";
};

const columnWidth = computed(() => (isSmallScreen.value ? 270 : 350));
const checkScreenSize = () => {
  isSmallScreen.value = window.innerWidth <= 768;
};
const displayDebtHeader = computed(() => {
  return window.innerWidth < 450
    ? `Very short term <span style="font-size: 14px; color: #DEDEDE;">3mo - 1.5yrs</span>`
    : "Very short term - 3 months to 1.5 yrs";
});
function sortByProperty(rowA, rowB, property) {
  const numA = parseFloat(rowA[property]);
  const numB = parseFloat(rowB[property]);

  if (isNaN(numA)) return 1;
  if (isNaN(numB)) return -1;

  return numA - numB;
}
const displayDebtShortHeader = computed(() => {
  return window.innerWidth < 450
    ? `Short term <span style="font-size: 14px; color: #DEDEDE;">1.5 - 3yrs</span>`
    : "Short term - 1.5 to 3 years ";
});
const displayDebtMediumHeader = computed(() => {
  return window.innerWidth < 450
    ? `Medium term <span style="font-size: 14px; color: #DEDEDE;">3 - 5yrs</span>`
    : "Medium term - 3 to 5 years ";
});
const displayDebtLongHeader = computed(() => {
  return window.innerWidth < 450
    ? `Long term <span style="font-size: 14px; color: #DEDEDE;">above 5 yrs</span>`
    : "Long term - above 5 years ";
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", checkScreenSize);
});

const isDialogVisible = ref(false);
const dialogContent = ref("");
const dialogTitle = ref("");
const openDialog = (title, content) => {
  dialogTitle.value = title;
  dialogContent.value = content;
  isDialogVisible.value = true;
};

const content1 = `These funds invest in debt instruments with maturities up to 90 days. They are useful for short horizons of a few weeks or months, or as part of your emergency portfolio`;
const content2 = `These funds invest in certificate of deposits from banks, commercial papers, treasury bills, bonds, debentures and other money market instruments with maturities of around a year or lower. Hold for at least 3 months or for longer periods`;
const content3 = `These funds invest in money market instruments, bank and corporate debt instruments of a short maturity. They need to be held for at least 1.5 years or longer`;
const content4 = `These funds invest in bank, corporate, and government debt instruments of longer maturities. They may hold instruments of lower credit quality, for higher return. These funds need to be held for a minimum of 3 years or longer`;
const content5 = `These funds span across categories such as gilt, short and medium term debt with potential to deliver steady returns over longer time frames. In the near to medium term, their risk remains high either because of holding risky papers or due to their duration strategy (interest rate risk). Hence they are ideally held for the long term`;
onMounted(() => {
  store.dispatch("fetchFunds");
  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);
});
const toggleWatchlist = async (fund) => {
  fund.statusMessage = "";
  fund.showStatusMsg = true;
  let success;
  if (Number(fund.inWatchlist) === 1) {
    fund.statusMessage = "Removing from Watchlist...";
    success = await store.dispatch("removemffromwatchlist", fund.schemeCode);
    if (success === true) {
      fund.inWatchlist = 0;
      fund.statusMessage = "Removed from Watchlist";
    } else {
      alert("Failed to remove from watchlist. Please try again.");
      fund.showStatusMsg = false;
    }
  } else {
    fund.statusMessage = "Adding to Watchlist...";
    success = await store.dispatch("saveMfWatchlist", fund.schemeCode);
    if (success === true) {
      fund.inWatchlist = 1;
      fund.statusMessage = "Added to Watchlist";
    } else {
      alert("Failed to add to watchlist. Please try again.");
      fund.showStatusMsg = false;
    }
  }
  setTimeout(() => {
    fund.showStatusMsg = false;
  }, 1000);
};

const selectedFund = ref({
  name: "",
  category: "",
  comment: "",
});
const isCommentPopupVisible = ref(false);

const showCommentPopup = (fund) => {
  isCommentPopupVisible.value = true;
  selectedFund.value.name = fund.name;
  selectedFund.value.category = fund.category;
  selectedFund.value.comment = fund.comment;
};
</script>

<style scoped>
.subscribe-container {
  z-index: 5;
  position: relative;
  top: 240px;
  margin-bottom: -35px;
  margin-top: -6%;
}

@media (max-width: 1199px) {
  .subscribe-container {
    top: 325px;
    margin-top: -8%;
  }
}

@media (min-width: 555px) and (max-width: 991px) {
  .subscribe-container {
    top: 325px;
    margin-top: -11%;
  }
}

@media (min-width: 450px) and (max-width: 554px) {
  .subscribe-container {
    top: 325px;
    margin-top: -18%;
  }
}

@media (max-width: 450px) {
  .subscribe-container {
    top: 325px;
    margin-top: -24%;
  }
}

.locked-message {
  display: block;
  font-size: 16px;
  margin-bottom: 12px;
  color: #333;
}

::v-deep .blur-row {
  filter: blur(9px) !important;
}
.funds-popup {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  cursor: pointer;
}

.fund-name {
  color: #00a3d9;
  font-weight: 600;
}

.watchlist-icon {
  cursor: pointer;
}

.prime-funds {
  position: relative;
}

::v-deep(.el-table .el-table__cell),
::v-deep(.el-table .cell) {
  padding: 0px !important;
}

.header-color {
  --el-table-header-bg-color: #0377a6;
}
.header-aggressive {
  --el-table-header-bg-color: #012e40;
}

.shadow-effect {
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
}

.new-tag {
  position: absolute;
  background-color: red;
  color: white;
  top: -6px;
  left: -19px;
  font-size: 8px;
  padding: 2px 18px 0px 18px;
  z-index: 10;
  font-weight: bold;
  transform: rotate(-45deg);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
}

.btn-color {
  background: #00a3d9 !important;
  border-radius: 10px;
  color: white !important;
  padding: 20px;
}

.gap-data {
  column-gap: 5px;
  padding: 10px;
  padding-left: 19px;
}

.custom-tabs .nav-link {
  border: 1px solid #ccc;
  border-radius: 0;
}

.watchlist-container td:first-child {
  position: relative;
}

.watchlist-status-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  pointer-events: none;
  background: linear-gradient(90deg, #012e40 0%, #ffffff 100%);
  padding: 13px !important;
}

.watchlist-status-message {
  font-size: 14px;
  color: white !important;
}

.watchlist-status-image {
  width: 100%;
  height: auto;
  background: linear-gradient(90deg, #012e40 0%, #ffffff 100%);
}

.custom-scrollable-table {
  --el-table-header-text-color: white;
  --el-table-header-font-weight: bold;
  --el-table-border-color: none;
  border: 1px solid black;
  position: relative;
  overflow: hidden;
  border-collapse: collapse;
}

@media (min-width: 769px) {
  .custom-scrollable-table {
    border-radius: 10px;
  }
}

::v-deep(.custom-scrollable-table tbody tr:last-child td) {
  border-bottom: none;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper thead tr th) {
  font-size: larger;
  padding: 5px !important;
}

::v-deep(.el-table .descending .sort-caret.descending) {
  border-top-color: white !important;
}

::v-deep(.el-table .ascending .sort-caret.ascending) {
  border-bottom-color: white !important;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper thead tr th),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td) {
  text-align: center !important;
}

::v-deep(.custom-scrollable-table .el-table__header-wrapper th:first-child),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td:first-child),
::v-deep(.custom-scrollable-table .el-table__body-wrapper td:last-child) {
  text-align: left !important;
}

::v-deep(.custom-scrollable-table tbody tr td) {
  border-bottom: 0.5px solid black;
  border-right: 0.5px solid black;
}

::v-deep(.custom-scrollable-table thead tr th) {
  border-bottom: 0.5px solid black;
  border-right: 0.5px solid black;
}

::v-deep(.custom-scrollable-table thead tr th:last-child),
::v-deep(.custom-scrollable-table tbody tr td:last-child) {
  border-right: none;
}

@media (max-width: 768px) {
  ::v-deep(.custom-scrollable-table thead tr th:first-child),
  ::v-deep(.custom-scrollable-table tbody tr td:first-child) {
    filter: drop-shadow(4px 4px 10px rgba(0, 0, 0, 0.25));
  }
}

::v-deep(.el-table__body, .el-table__footer) {
  margin: 0 !important;
}

::v-deep(.el-table__header),
::v-deep(.el-table__body) {
  margin: 0 !important;
  width: 100% !important;
}

::v-deep(.dialog-color .el-dialog__header .el-dialog__headerbtn) {
  background: white !important;
}
</style>
